export default "__VITE_ASSET__7148dd4c__"